import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName, useTheme } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';
import GameItem from '../items/Game';

import styles from '../../../styles/lists/games.module.scss';

const propTypes = {
    className: PropTypes.string,
    visibleCount: PropTypes.number,
    items: AppPropTypes.games.isRequired,
};

const defaultProps = {
    visibleCount: 3,
    className: null,
};

function UpcomingGamesList({ items, visibleCount, className }) {
    const { name: theme } = useTheme();
    const themeClassName = useThemeClassName(styles);

    const [showMore, setShowMore] = useState(false);
    const toggleShowMore = useCallback(() => setShowMore(true), []);

    const finalItems = showMore ? items : (items || []).slice(0, visibleCount);
    const finalCount = (items || []).length - (finalItems || []).length;

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            {finalItems.map((game) => (
                <GameItem
                    className={styles.item}
                    key={`game-${game.id}`}
                    game={game}
                    theme={theme}
                    canParticipate={game.canParticipate}
                />
            ))}
            {finalCount > 0 ? (
                <>
                    <p className={styles.more}>
                        <FormattedMessage
                            defaultMessage="And {count} more..."
                            description="List label"
                            values={{ count: finalCount }}
                        />
                    </p>
                    <StyledButton className={styles.moreButton} onClick={toggleShowMore}>
                        <FormattedMessage defaultMessage="Show more" description="Button label" />
                    </StyledButton>
                </>
            ) : null}
        </div>
    );
}

UpcomingGamesList.propTypes = propTypes;
UpcomingGamesList.defaultProps = defaultProps;

export default UpcomingGamesList;
